// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"explore"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M4.92893 19.0711C1.02369 15.1659 1.02369 8.83424 4.92893 4.92899C8.83417 1.02375 15.1658 1.02375 19.0711 4.92899C22.9763 8.83424 22.9763 15.1659 19.0711 19.0711C15.1658 22.9764 8.83418 22.9764 4.92893 19.0711Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M7.40039 11.4928L15.7017 8.29999L12.5089 16.6012L11.1581 12.8436L7.40039 11.4928Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M4.92893 19.0711C1.02369 15.1659 1.02369 8.83424 4.92893 4.92899C8.83417 1.02375 15.1658 1.02375 19.0711 4.92899C22.9763 8.83424 22.9763 15.1659 19.0711 19.0711C15.1658 22.9764 8.83418 22.9764 4.92893 19.0711Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M7.40039 11.4928L15.7017 8.29999L12.5089 16.6012L11.1581 12.8436L7.40039 11.4928Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ExploreIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'explore',
    ref,
    icon: element,
  },
));

ExploreIcon.displayName = 'ExploreIcon';

export default ExploreIcon;
